module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item !== undefined && _vm.item !== null) ? _c('div', {
    staticClass: "question-detail"
  }, [_c('div', {
    staticClass: "item-question col-md-12"
  }, [(_vm.item.detailLink && _vm.item.detailLink !== undefined && _vm.item.detailLink.length > 0) ? _c('div', {
    staticClass: "big-audio"
  }, [_c('audio', {
    attrs: {
      "id": "player",
      "controls": "controls",
      "width": "50%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.item.detailLink,
      "type": "audio/mp3"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "big-question"
  }, [_vm._v(_vm._s(_vm.$mycontroller.stripHtml(_vm.item.content)))])]), _c('div', {
    staticClass: "item-question-number"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('landing.exercise.question')) + " " + _vm._s(_vm.current) + "/" + _vm._s(_vm.total))])])]), _c('div', {
    staticClass: "item-question col-md-12"
  }, [_c('div', {
    staticClass: "small-question"
  }, [_vm._v(_vm._s(_vm.$mycontroller.stripHtml(_vm.item.detailContent)))])]), (_vm.item.detailType === 2) ? _c('div', {
    staticClass: "item-answer col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('landing.exercise.answer')))]), _c('itemFloara', {
    attrs: {
      "answer": _vm.item.detailValueContent
    },
    on: {
      "pushContent": _vm.pushContent
    }
  })], 1) : (_vm.item.detailType === 1 && _vm.item.detailAnswers !== null) ? _c('div', {
    staticClass: "item-answer col-md-12"
  }, _vm._l((_vm.item.detailAnswers), function(itemAnswer, index) {
    return _c('div', {
      staticClass: "answer-charactor",
      class: [_vm.answerIDs.includes(itemAnswer.id) ? 'current' : ''],
      on: {
        "click": function($event) {
          return _vm.clickAnswer(itemAnswer)
        }
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.$mycontroller.convertToAlphabet(index)) + ". " + _vm._s(_vm.$mycontroller.stripHtml(itemAnswer.content)))])])
  }), 0) : _vm._e(), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d378330","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/question.vue
// module id = 1537
// module chunks = 0